// Wrapper around Facebook Pixel (window.fbq) — safe to call before the script loads.
export const FB_PIXEL_ID = "565806553212279";

export const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    try {
      window.fbq(...args);
    } catch (e) {
      // noop — we never want tracking to break the UI
    }
  }
};

// Standard events: Lead, ViewContent, Contact, InitiateCheckout, Search, CompleteRegistration
export const trackEvent = (event, params = {}) => fbq("track", event, params);

// Custom events (for actions without a standard counterpart)
export const trackCustomEvent = (event, params = {}) => fbq("trackCustom", event, params);

export const trackPageView = () => fbq("track", "PageView");
